import { Router } from "express";

import { classController } from "../controllers/class-controller";
import {
  authenticate,
  createRateLimit,
  requireEmailVerification,
} from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";

const router = Router();

// Environment-aware rate limiting
const generalRateLimit = createRateLimit.general();

// Apply authentication and teacher role requirement to all routes
router.use(authenticate);
router.use(requireEmailVerification);
router.use(requireRole(["teacher"]));

/**
 * TEACHER MOBILE APP - CLASS ROUTES
 */

/**
 * @route   GET /api/v1/teacher/classes
 * @desc    Get all teacher's classes
 * @access  Private (Teacher)
 */
router.get("/classes", generalRateLimit, (req, res) =>
  classController.getTeacherClasses(req, res),
);

/**
 * @route   GET /api/v1/teacher/classes/:id
 * @desc    Get specific class details for teacher
 * @access  Private (Teacher)
 */
router.get("/classes/:id", generalRateLimit, (req, res) =>
  classController.getTeacherClassById(req, res),
);

/**
 * @route   GET /api/v1/teacher/classes/:id/students
 * @desc    Get students for teacher's class
 * @access  Private (Teacher)
 */
router.get("/classes/:id/students", generalRateLimit, (req, res) =>
  classController.getTeacherClassStudents(req, res),
);

export { router as teacherMobileRoutes };
